import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from '@pages/NoticeExtractor/components/Content';

export const NoticeExtractor = () => {
  return (
    <>
      <Helmet>
        <title>Notice Extractor - AutoScript Admin</title>
      </Helmet>
      <Header title="Notice Extractor" />
      <Content />
    </>
  );
};
